import React from 'react';

export const GridContext = React.createContext({
  columns: 0,
  loadMore: () => {},
  isOnlyCover: false,
  gutter: {}
});
